module.exports = __webpack_public_path__ + "img/pipe_output.b907f538.svg";